"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RagFailed = exports.RagAlert = exports.RagSuccess = void 0;

var _constants = require("../../constants");

var _icons = require("@material-ui/icons/");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const RagSuccess = (0, _styledComponents.default)(_icons.CheckCircleOutline).attrs(() => ({
  title: 'Success'
}))`
	color: ${_constants.colours.green};
`;
exports.RagSuccess = RagSuccess;
const RagAlert = (0, _styledComponents.default)(_icons.ErrorOutline).attrs(() => ({
  title: 'Alert'
}))`
	color: ${_constants.colours.amber};
`;
exports.RagAlert = RagAlert;
const RagFailed = (0, _styledComponents.default)(_icons.ErrorOutline).attrs(() => ({
  title: 'Fail'
}))`
	color: ${_constants.colours.red};
`;
exports.RagFailed = RagFailed;